"use strict";

(function () {
    // перевёл на Vue, но не всё, поэтому оставил эту заглушку
    Fotobook.bottomPanel = {};
})();
